/**
 * Liên kết hành động nhanh trên dashboard admin — icon, mô tả và điều hướng.
 */
import { Link } from 'react-router-dom';

export const DashboardQuickAction = ({ to, title, description, icon, accent = '#2563eb' }) => (
  <Link
    to={to}
    className="admin-dashboard-action"
    style={{ '--action-accent': accent }}
  >
    <span className="admin-dashboard-action-icon" aria-hidden="true">
      {icon}
    </span>
    <span className="admin-dashboard-action-copy">
      <strong>{title}</strong>
      <span>{description}</span>
    </span>
    <span className="admin-dashboard-action-arrow" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
        <path
          d="M9 6l6 6-6 6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  </Link>
);
